__turbopack_context__.v({
  "mobileSelect": "index-module__yBmMmq__mobileSelect",
  "navigation": "index-module__yBmMmq__navigation",
  "wrapper": "index-module__yBmMmq__wrapper",
});
